import * as React from 'react';
import './FlightInfoTime.css';
import { Row, Col } from 'antd';
import FlightConnections from './flightConnections/FlightConnections';
import i18n from 'i18n-react';
import PropTypes from 'prop-types';

const propTypes = {
  background: PropTypes.any,
  departureFlight: PropTypes.any,
  arrivalFlight: PropTypes.any,
  hasAirportChange: PropTypes.any,
  hideConnectionLine: PropTypes.any,
  isDepartureFlight: PropTypes.any,
  flightGroup: PropTypes.any
};

function FlightInfoTime(props) {
  const bgColor = props.background ? `bg-${props.background}` : 'bg-white-three';
  return (
    <div>
      <Row className={`FlightInfoTime text-xxl ${bgColor}`}>
        <Col span={8} className="FlightInfoTime__departureTime">
          <div className="FlightInfoTime__hour text-brownish-gray">
            <p data-test="departureFlightTime">{props.departureFlight.time}</p>
          </div>
          <div className="FlightInfoTime__departure text-silver">
            <p data-test="departureFlight">{props.departureFlight.airportSign}</p>
          </div>
        </Col>
        <Col span={6} className="FlightInfoTime__connections">
          {printConnectionLine(props)}
        </Col>
        <Col span={10} className="FlightInfoTime__arrivalTime">
          <div className="FlightInfoTime__hour text-brownish-gray">
            <p data-test="arrivalFlightTime">{props.arrivalFlight.time}</p>
          </div>
          <div className="FlightInfoTime__arrival text-silver">
            <p data-test="arrivalFlight">{props.arrivalFlight.airportSign}</p>
            <p
              data-test="plusDays"
              className="FlightInfoTime__plusDays padding-eight-left-8 text-xs">
              {formatPlusDays(props)}
            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col
          data-test="stopsMessage"
          span={22}
          className={`FlightInfoTime__stops text-sm ${
            props.hasAirportChange ? 'text-red-wine' : ''
          }`}>
          {getStopFlights(props)}
        </Col>
      </Row>
    </div>
  );
}

function printConnectionLine(props) {
  let printConnections;
  if (props.hideConnectionLine) {
    printConnections = (
      <div className="FlightInfoTime__caretRight text-center text-light-gray">
        <i className="icon-caret-right" />
      </div>
    );
  } else {
    printConnections = (
      <FlightConnections
        isDepartureFlight={props.isDepartureFlight}
        flightGroup={props.flightGroup}
      />
    );
  }

  return printConnections;
}

function formatPlusDays(props) {
  const plusDays = props.arrivalFlight.plusDays;
  let formatPlusDaysMessage = '';
  if (plusDays === 1) {
    formatPlusDaysMessage = `+${plusDays} ${i18n.translate('features.flightInfoTime.day')}`;
  } else if (plusDays > 1) {
    formatPlusDaysMessage = `+${plusDays} ${i18n.translate('features.flightInfoTime.days')}`;
  }
  return formatPlusDaysMessage;
}

function getStopFlights(props) {
  let stopFlights = 0;
  let stopMessage = '';

  if (!props.hideConnectionLine) {
    stopFlights = props.flightGroup.length - 1 || 0;

    if (stopFlights === 1) {
      stopMessage = `${stopFlights} ${i18n.translate('features.flightInfoTime.stopFlight')}`;
    } else if (stopFlights > 1) {
      stopMessage = `${stopFlights} ${i18n.translate('features.flightInfoTime.stopFlights')}`;
    } else {
      stopMessage = i18n.translate('features.flightInfoTime.directFlight').toString();
    }

    if (props.hasAirportChange) {
      stopMessage = `${stopMessage} ${i18n.translate('features.flightInfoTime.withAirportChange')}`;
    }
  }
  return stopMessage;
}

FlightInfoTime.propTypes = propTypes;

export default FlightInfoTime;



// WEBPACK FOOTER //
// ./src/page/flightDetailsPage/components/flightInfoTime/FlightInfoTime.jsx